import styled from "styled-components"
 
export const GenreProfileContainerStyled = styled.div`

`